// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"37456325","239":"c4c40f55","520":"3891cc7f","544":"d52fbceb","732":"e4723c08","816":"8d6d9745","933":"62504f5f","977":"7ccb42ee"}[chunkId] + ".chunk.js";
};